import { Ref } from "vue"

export const change = <T>(event: Event, dataInput: Ref<T>) => {
    const eventTarget = event.target as HTMLInputElement
    dataInput.value = {...dataInput.value, [eventTarget.name]: eventTarget.value.replaceAll(' ', '')}
}